module.exports = __webpack_public_path__ + "img/Hoersystemakustiker.f9d47c38.jpg";